import spinnerIcon from '@iconify/icons-material-symbols/progress-activity';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { ErrorMessageBlock } from '#pie/components/error-message/ErrorMessageBlock';
import { Icon } from '#pie/components/icon/Icon';
import { Page, PageHeader } from '#pie/components/page/Page';
import { PageHead } from '#pie/components/page-head/PageHead';
import { Stack } from '#pie/components/stack/Stack';
import { useGetMarketParticipantOrganisationById } from '#pie/internal/api/pie-bff';
import { toMarketPartyRegistration } from '#pie/pages/organisation-management/market-party-registration/marketPartyRegistrationAdapter';
import { useStoredParams } from '#pie/stores/searchParams';
import { MarketPartyCompany } from '../organisation-management/market-party-registration/MarketPartyCompany';
import { MarketPartyLicense } from '../organisation-management/market-party-registration/MarketPartyLicense';
import { MarketPartyRegistrationDetails } from '../organisation-management/market-party-registration/MarketPartyRegistrationDetails';
import { MarketPartySubRegistration } from '../organisation-management/market-party-registration/MarketPartySubRegistration';

export const MarketPartiesRegistryDetail = () => {
  const { t } = useTranslation('marketParty');
  const { t: tcom } = useTranslation();
  const mprId = useParams()['mprId']!;
  const params = useStoredParams('/marktpartijenregister');

  const { data, isLoading, error } =
    useGetMarketParticipantOrganisationById(mprId);

  const marketParty = data != null ? toMarketPartyRegistration(data) : null;
  const hasDataError = !isLoading && (error != null || data == null);

  return (
    <>
      <PageHead
        title={t('market_parties_registry.detail.title', {
          mprAccountName: data?.organisation?.statutoryName,
        })}
      />
      <Page>
        <PageHeader
          title={t('market_parties_registry.detail.title', {
            mprAccountName: data?.organisation?.statutoryName,
          })}
          backHref={`/marktpartijenregister${params}`}
          previousText={tcom('common.button.back')}
        />
        <Stack gap="lg" className="mx-auto my-6 max-w-4xl">
          {hasDataError ? (
            <ErrorMessageBlock
              className="ml-6"
              error={error ?? new Error('No market party data returned')}
            />
          ) : isLoading ? (
            <Icon
              role="progressbar"
              aria-label="loading"
              icon={spinnerIcon}
              size={48}
              className="m-auto animate-spin text-content-tertiary opacity-50"
            />
          ) : marketParty != null ? (
            <>
              <MarketPartyCompany marketParty={marketParty} />
              <MarketPartyLicense marketParty={marketParty} />
              <MarketPartyRegistrationDetails
                marketParty={marketParty}
                showQuickLinks
              />
              <MarketPartySubRegistration marketParty={marketParty} />
            </>
          ) : null}
        </Stack>
      </Page>
    </>
  );
};
